import { render, staticRenderFns } from "./CategoriesCategory.vue?vue&type=template&id=16f14171&scoped=true&"
import script from "./CategoriesCategory.vue?vue&type=script&lang=js&"
export * from "./CategoriesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f14171",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BDropdownItem, BDropdown} from 'bootstrap-vue'
    installComponents(component, {BDropdownItem, BDropdown})
    

export default component.exports